import { useEffect, useId, useRef, type MouseEvent } from "react";

interface ErrorSummaryProps {
  errors: Record<string, string>;
  title?: string;
  /** Optional DOM id overrides for forms rendered more than once on a page. */
  fieldIds?: Record<string, string>;
}

export function ErrorSummary({ errors, title = "There is a problem", fieldIds = {} }: ErrorSummaryProps) {
  const ref = useRef<HTMLDivElement>(null);
  const titleId = useId();
  const entries = Object.entries(errors).filter(([, message]) => message);
  useEffect(() => { if (entries.length) ref.current?.focus(); }, [entries.length]);
  const focusField = (event: MouseEvent<HTMLAnchorElement>, field: string) => {
    const target = document.getElementById(fieldIds[field] ?? field);
    if (!(target instanceof HTMLElement)) return;
    event.preventDefault();
    target.focus();
  };
  if (!entries.length) return null;
  return (
    <div className="error-summary" role="alert" tabIndex={-1} ref={ref} aria-labelledby={titleId}>
      <h2 id={titleId}>{title}</h2>
      <ul>
        {entries.map(([field, message]) => (
          <li key={field}>{field === "page" ? message : <a href={`#${fieldIds[field] ?? field}`} onClick={(event) => focusField(event, field)}>{message}</a>}</li>
        ))}
      </ul>
    </div>
  );
}
